// import Vue from "vue";

export const densityList = [
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 1010101,
    list: [
      // 10035_2: "AL7075", 10035_3: "AL5052", 10035_1: "AL6061"
      { aId: "10035_1", bId: "10037_1", value: 0.00000275 },
      { aId: "10035_1", bId: "10037_2", value: 0.0000027 },
      { aId: "10035_2", bId: "10037_1", value: 0.0000028 },
      { aId: "10035_2", bId: "10037_2", value: 0.00000282 },
      { aId: "10035_3", value: 0.00000268 },
      { aId: "", value: 0.0000028 },
    ],
    densityParams:[1002037,1002038],
    shapeParams:[1002086, 1002087, 1002088],
    massId:1002089,
    formula: (a,b,c) =>{return a * b * c}
  },
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 9020235,
    list: [
      // 10035_2: "AL7075", 10035_3: "AL5052", 10035_1: "AL6061"
      { aId: "10047_1", bId: "10049_1", value: 0.00000275 },
      { aId: "10047_1", bId: "10049_2", value: 0.0000027 },
      { aId: "10047_2", bId: "10049_1", value: 0.0000028 },
      { aId: "10047_2", bId: "10049_2", value: 0.00000282 },
      { aId: "10047_3", value: 0.00000268 },
      { aId: "", value: 0.0000028 },
    ],
    densityParams:[1002037,1002038],
    shapeParams:[1002086, 1002087],
    massId:1002088,
    formula: (a,b) =>{return (Math.PI * a * a * b) / 4},
  },
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 9020236,
    list: [
      // 10035_2: "AL7075", 10035_3: "AL5052", 10035_1: "AL6061"
      { aId: "10053_1", bId: "10054_1", value: 0.00000275 },
      { aId: "10053_1", bId: "10054_2", value: 0.0000027 },
      { aId: "10053_2", bId: "10054_1", value: 0.0000028 },
      { aId: "10053_2", bId: "10054_2", value: 0.00000282 },
      { aId: "10053_3", value: 0.00000268 },
      { aId: "", value: 0.0000028 },
    ],
    densityParams:[1002037, 1002038],
    shapeParams:[1002086, 1002087, 1002088 ],
    massId:1002089,
    formula: (a,b,c) => {return ((b * b - (a * a)) * c * Math.PI) / 4},
  },
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 9020237,
    list: [
      // 10035_2: "AL7075", 10035_3: "AL5052", 10035_1: "AL6061"
      { aId: "10035_1", bId: "10037_1", value: 0.00000275 },
      { aId: "10035_1", bId: "10037_2", value: 0.0000027 },
      { aId: "10035_2", bId: "10037_1", value: 0.0000028 },
      { aId: "10035_2", bId: "10037_2", value: 0.00000282 },
      { aId: "10035_3", value: 0.00000268 },
      { aId: "", value: 0.0000028 },
    ],
    densityParams:[1002037],
    shapeParams:[1002086, 1002087],
    massId:1002088,
    formula: (a,b) => {return a * b},
  },
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 9020238,
    list: [
      // 10060_2: "AL7075", 10060_3: "AL5052", 10060_1: "AL6061"
      { aId: "10060_1", value: 0.00000793 },
      { aId: "10060_2", value: 0.00000793 },
      { aId: "10060_3", value: 0.00000798 },
      { aId: "10060_4", value: 0.00000798 },
      { aId: "", value: 0.000008 },
    ],
    densityParams:[1002037],
    shapeParams:[1002086, 1002087, 1002088],
    massId:1002089,
    formula: (a,b,c) =>{return a * b * c}
  },
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 9020239,
    list: [
      // 10069_2: "AL7075", 10069_3: "AL5052", 10069_1: "AL6061"
      { aId: "10069_1", value: 0.00000793 },
      { aId: "10069_2", value: 0.00000793 },
      { aId: "10069_3", value: 0.00000798 },
      { aId: "10069_4", value: 0.00000798 },
      { aId: "", value: 0.000008 },
    ],
    densityParams:[1002037],
    shapeParams:[1002086, 1002087],
    massId:1002088,
    formula: (a,b) =>{return (Math.PI * a * a * b) / 4},
  },
  {
    // subClassIdList: [1010101, 9020235, 9020236, 9020237],
    subClassId: 9020240,
    list: [
      // 10060_2: "AL7075", 10060_3: "AL5052", 10060_1: "AL6061"
      { aId: "10072_1", value: 0.00000793 },
      { aId: "10072_2", value: 0.00000793 },
      { aId: "10072_3", value: 0.00000798 },
      { aId: "10072_4", value: 0.00000798 },
      { aId: "", value: 0.000008 },
    ],
    densityParams:[1002037],
    shapeParams:[1002086, 1002087, 1002088 ],
    massId:1002089,
    formula: (a,b,c) => {return ((b * b - (a * a)) * c * Math.PI) / 4},
  },
];

export const formulaList = [
  {
    idList: [1010101], //板材  板厚*宽度*长度
    densityParams:[1002037,1002038],
    shapeParams:[1002086, 1002087, 1002088],
    massId:1002089,
    formula: (a,b,c) =>{return a * b * c}
  },
  {
    idList: [9020235], //圆棒料、圆盘  π*外径²/4*长度
    densityParams:[1002037,1002038],
    shapeParams:[1002086, 1002087],
    massId:1002088,
    formula: (a,b) =>{return (Math.PI * a * a * b) / 4},
  },
  {
    idList: [9020236], //圆环、管料 π*（外径²-内径²）/4*长度
    densityParams:[1002037, 1002038],
    shapeParams:[1002086, 1002087, 1002088 ],
    massId:1002089,
    formula: (a,b,c) => {return ((b * b - (a * a)) * c * Math.PI) / 4},
  },
  {
    idList: [9020237], //型材 截面面积*长度
    densityParams:[1002037],
    shapeParams:[1002086, 1002087],
    massId:1002088,
    formula: (a,b) => {return a * b},
  },
  {
    idList: [9020238], //板材  板厚*宽度*长度
    densityParams:[1002037,],
    shapeParams:[1002086, 1002087, 1002088],
    massId:1002089,
    formula: (a,b,c) =>{return a * b * c}
  },
  {
    idList: [9020239], //圆棒料、圆盘  π*外径²/4*长度
    densityParams:[1002037],
    shapeParams:[1002086, 1002087],
    massId:1002088,
    formula: (a,b) =>{return (Math.PI * a * a * b) / 4},
  },
  {
    idList: [9020240], //圆环、管料 π*（外径²-内径²）/4*长度
    densityParams:[1002037],
    shapeParams:[1002086, 1002087, 1002088 ],
    massId:1002089,
    formula: (a,b,c) => {return ((b * b - (a * a)) * c * Math.PI) / 4},
  },
 
];
